import React from 'react';

import { Jumbotron, Table, Button } from 'reactstrap';

import Footer from '~/Components/Footer';
import { host } from '~/config/api';
import tutorialAtualizado from '~/assets/documents/tutorial_atualizado.pdf';

import { Content, Section, ButtonGroup } from './styles';

const Geoservices = () => {
	function openLink(href) {
		const link = document.createElement('a');
		link.href = href;
		link.target = '_blank';
		link.click();
	}

	return (
		<>
			<Content>
				<Section>
					<Jumbotron style={{ background: 'transparent' }}>
						<h1 className="display-6">CATÁLOGO DE GEOSERVIÇOS</h1>
						<p className="lead">
							Geoserviços é conjunto de funcionalidades que
							permite o acesso e uso aberto de informações
							geoespaciais por meio de um navegador de internet ou
							software de geoprocessamento.{' '}
							<a
								target="_blank"
								rel="noopener noreferrer"
								href={tutorialAtualizado}
								download="tutorial_atualizado.pdf"
								style={{ color: 'var(--red)' }}
							>
								Clique aqui
							</a>{' '}
							e faça download do tutorial para utilizar o
							Geoserviços.
						</p>

						<Table striped hover>
							<thead>
								<tr>
									<th className="p-3">INSTITUIÇÃO</th>
									<th className="p-3">SERVIÇOS</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td
										className="p-2 align-middle"
										style={{ width: '100%' }}
									>
										SIG Gramado - Sistema de Geoprocessamento
									</td>
									<td className="p-2 text-right align-middle">
										<ButtonGroup>
											<Button
												color="info"
												size="sm"
												onClick={() =>
													openLink(
														`${host}geoserver/Geoportal/ows?service=wms&version=1.3.0&request=GetCapabilities`
													)
												}
											>
												WMS
											</Button>
											{/* <Button
												color="info"
												size="sm"
												onClick={() =>
													openLink(
														`${host}geoserver/Geoportal/ows?service=wfs&version=1.3.0&request=GetCapabilities`
													)
												}
											>
												WFS
											</Button> */}
											<Button
												color="success"
												size="sm"
												onClick={() => openLink('/map')}
											>
												Mapas
											</Button>
										</ButtonGroup>
									</td>
								</tr>
							</tbody>
						</Table>
					</Jumbotron>
				</Section>
			</Content>
			<Footer />
		</>
	);
};

export default Geoservices;
